<template>
  <div class="contain">
    
    <div class="enr_con">
       <div class="imgurl"> <img src="../assets/images/22.png" alt=""> </div>
      <p class="navigation fl">您当前所在的位置：
        <router-link to="/home/index" class="home">首页</router-link>&nbsp;>&nbsp;<a href="javascript:;" style="color:#666" >打印准考证</a>
      </p>
      <div class="main">
        <left-comp></left-comp>
        <div class="enr_right pr">
          <div id="formbutton">
            <a :href="Link_Url.logoUrl+data.url" class="btn"  target="_blank" download>下载</a>
            <a href="javascript:;" class="btns mt15" v-print="'#pdfDom'">打印</a>
          </div>
        
         
          <!--有数据的时候展示-->
          <div v-if="flag" id="pdfDom">
            <div class="picture">
              <img :src="Link_Url.logoUrl+data.url" >
            </div>
          </div>
          <!-- 没有数据时候展示-->
          <div v-show="flags" class="nodata">
            抱歉，暂未查询到消息~
          </div>
        </div>
      </div>
    </div>
    <page-load v-if="loading"></page-load>
    <!-- 提示框 -->
    <tip :tip="tip" v-show="tipShow"></tip>
  </div>
</template>

<script>
import leftComp from "../components/leftComp";
import { examCard } from "../api/updata";
// import  url  from "../api/config";
import { Link_Url } from "../api/config";
import pageLoad from "../pageload/pageload";

export default {
  components: { leftComp, pageLoad },
  data() {
    return {
      batch_id: "", //批次
      sfzjh: "", //身份证件号
      data: {}, //保存数据
      // url: "http://api.cz.365mooc.cn/",
      Link_Url: Link_Url,
      flag: false,
      flags: false,
      errImg: 'this.src="' + require("../assets/images/moren.jpg") + '"', //默认图片
      htmlTitle: "", //下载附件名称
      tip: {}, //提示语
      loading: true, //预加载
      tipShow: false //提示框默认状态
    };
  },
  created() {
    this.sfzjh = JSON.parse(
      this.global.Base64.decode(sessionStorage.getItem("INFO"))
    ).sfzjh; //身份证件号
    this.htmlTitle = JSON.parse(
      this.global.Base64.decode(sessionStorage.getItem("INFO"))
    ).xm; //下载附件名称
    this.batch_id = JSON.parse(
      this.global.Base64.decode(sessionStorage.getItem("INFO"))
    ).batch_id; //批次

    this._examCard();
  },
  methods: {
    // 获取准考证信息
    _examCard() {
      if (
        this.sfzjh == null ||
        this.htmlTitle == null ||
        this.batch_id == null
      ) {
        this.loading = false;
        this.tipCtr("学生信息缺失");
      } else {
        let module = {
          sfzjh: this.global.Base64.encode(
            JSON.parse(Base64.decode(sessionStorage.getItem("INFO"))).sfzjh
          ),
          sch_id: 1,
          batch_id: this.batch_id
        };
        this.loading = true;
        examCard(module)
          .then(res => {
            this.loading = false;
            if (res.status && res.data) {
              this.flag = true;
              this.data = res.data;
            } else {
              this.flags = true;
            }
          })
          .catch(err => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      }
    },
    //提示框函数
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1200);
    }
  }
};
</script>

<style scoped>
.picture {
  width: 100%;
  margin: 0 auto;
  padding-top: 60px;
}
.picture img {
  width: 100%;
}
.nodata {
  width: 100%;
  text-align: center;
  font-size: 18px;
  margin-top: 200px;
}
#formbutton {
  position: absolute;
  top: 6px;
  right: 5px;
}

.card {
  margin-left: 150px;
}
table {
  margin-bottom: 60px;
}
.enr_right {
  width: 100%;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px 0 #e0e0e0;
}
.btns {
  border-radius: 4px;
  padding: 0 40px;
  height: 38px;
  line-height: 38px;
  color: #3a5ae1;
  border: 1px solid #3a5ae1;
  font-size: 16px;
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/print.vue